export const LOG_IN_PAGE_TITLE = 'Log In';
export const LOGIN_SUCCESS_PAGE_TITLE = 'Login Success!';
export const SIGN_UP_PAGE_TITLE = 'Sign Up';
export const VERIFY_YOUR_EMAIL_ADDRESS_PAGE_TITLE = 'Verify your email address';
export const EMAIL_CONFIRMATION_PAGE_TITLE = 'Email confirmation';
export const EMAIL_IS_CONFIRMED_PAGE_TITLE = 'Email is confirmed!';
export const USER_DELETED_PAGE_TITLE = 'User Deleted';
export const COMPLETE_REGISTRATION_PAGE_TITLE = 'Set password to SignUp';

export const FORGOT_YOUR_PASSWORD_PAGE_TITLE = 'Forgot your password?';
export const PASSWORD_RESET_EMAIL_SENT_PAGE_TITLE = 'Password Reset Email Sent';
export const SET_NEW_PASSWORD_PAGE_TITLE = 'Set New Password';
export const NEW_PASSWORD_WAS_SET_PAGE_TITLE = 'New Password Was Set!';

export const PROFILE_PAGE_TITLE = 'Profile';

export const ORGANIZATION_ACCOUNT_PAGE_TITLE = 'Organization - Account';
export const ORGANIZATION_USERS_PAGE_TITLE = 'Organization - Users';
export const SERVER_USERS_PAGE_TITLE = 'Server - Users';

export const PROJECT_ENVIRONMENTS_PAGE_TITLE = 'Project - Environments';
export const PROJECT_GIVENS_PAGE_TITLE = 'Project - Givens';
export const PROJECT_ROLES_PAGE_TITLE = 'Project - Access Roles';
export const PROJECT_CONNECTIONS_PAGE_TITLE = 'Project - Connections';
export const PROJECT_PROVIDERS_PAGE_TITLE = 'Project - LLM Providers';
export const PROJECT_INFO_PAGE_TITLE = 'Project - Info';
export const PROJECT_TEAM_PAGE_TITLE = 'Project - Team';
export const PROJECT_SANDBOX_PROVIDER_PAGE_TITLE = 'Project - Sandbox Provider';

export const BUILDER_PAGE_TITLE = 'Builder';
export const EXPLORER_PAGE_TITLE = 'Explorer';
export const CHARTS_PAGE_TITLE = 'Charts';
export const CHARTS_LIST_PAGE_TITLE = 'Charts List';
export const MODELS_LIST_PAGE_TITLE = 'Models List';
export const DASHBOARDS_PAGE_TITLE = 'Dashboards';
export const DASHBOARD_PAGE_TITLE = 'Dashboard';
export const REPORTS_PAGE_TITLE = 'Reports';

export const PAGE_NOT_FOUND_PAGE_TITLE = 'Page Not Found';
export const ORGANIZATION_DELETED_PAGE_TITLE = 'Organization Deleted';
export const ORGANIZATION_OWNER_CHANGED_PAGE_TITLE =
  'Organization Owner Changed';
export const PROJECT_DELETED_PAGE_TITLE = 'Project Deleted';
